const mediaItems = [
  {
    id: 1,
    title: '暗夜追凶 第24集',
    source: '妖精视频',
    views: '128万',
    tag: '更新中',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20series%20promotional%20visual%2C%20atmospheric%20night%20urban%20scene%20with%20mysterious%20moody%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20cinematic%20suspense%20thriller%20aesthetic%2C%20professional%20drama%20production%20quality%2C%20clean%20minimal%20composition%2C%20modern%20Chinese%20television%20style%20with%20premium%20visual%20design&width=400&height=280&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '春风十里不如你 全36集',
    source: '桃花视频',
    views: '96万',
    tag: '已完结',
    img: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20Chinese%20modern%20drama%20visual%2C%20bright%20airy%20natural%20lighting%20with%20spring%20outdoor%20setting%2C%20soft%20coral%20and%20pastel%20tones%2C%20young%20couple%20in%20cherry%20blossom%20scene%2C%20cinematic%20emotional%20storytelling%20aesthetic%2C%20feel-good%20romance%20series%20quality%2C%20clean%20elegant%20composition&width=400&height=280&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '长安秘事录 第18集',
    source: '苹果视频',
    views: '85万',
    tag: '更新中',
    img: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20costume%20drama%20promotional%20poster%2C%20elegant%20traditional%20palace%20setting%20with%20warm%20golden%20hour%20lighting%2C%20rich%20amber%20and%20red%20tones%2C%20flowing%20traditional%20fabrics%20in%20dramatic%20composition%2C%20premium%20period%20drama%20production%20quality%2C%20cinematic%20artistic%20visual%20design&width=400&height=280&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '山海异兽录 第10集',
    source: '榴莲视频',
    views: '72万',
    tag: '热播中',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20adventure%20series%20artwork%2C%20dramatic%20mountainous%20landscape%20with%20magical%20elements%2C%20warm%20golden%20sunset%20lighting%20with%20mystical%20atmosphere%2C%20rich%20coral%20and%20amber%20color%20palette%2C%20cinematic%20wide%20composition%20with%20heroic%20vibes%2C%20premium%20production%20value%20visual&width=400&height=280&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '追光者 全24集',
    source: '豆花视频',
    views: '68万',
    tag: '已完结',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20workplace%20drama%20visual%2C%20contemporary%20city%20office%20setting%20with%20warm%20natural%20light%2C%20soft%20professional%20aesthetic%20with%20coral%20accents%2C%20young%20professional%20actors%20in%20stylish%20business%20attire%2C%20cinematic%20clean%20composition%2C%20premium%20office%20drama%20production%20quality%2C%20elegant%20minimal%20design&width=400&height=280&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-play-circle-line"></i>
            每日更新
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            精选热播
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选妖精视频、桃花视频等平台最新最热影视剧，高清在线观看完整版
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden mb-3 aspect-[4/3] bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-[10px] font-medium whitespace-nowrap">
                  {item.tag}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-foreground-950 font-medium text-sm truncate group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-foreground-500 text-xs">{item.source}</span>
                <span className="text-foreground-400 text-xs">·</span>
                <span className="text-foreground-500 text-xs">{item.views}次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}